import React from 'react';
import { DATA_TID } from '@/infrastructure/cypress-ids';
import { TagInfo } from '@/presentation/pages/setting/tag-manage/api';
import { TAG_COLOR_INFO } from '@/presentation/pages/setting/tag-manage/config';
import { EditTagModal, DeleteTagModal } from '@/presentation/pages/setting/tag-manage/modal';

const renderOperate = (data: TagInfo, updateTagList: () => void, tagList: TagInfo[]) => <>
  <EditTagModal
    tagId={data.tagId!}
    tagName={data.tagName!}
    onSubmit={updateTagList}
    tagList={tagList}
    tagColor={data.tagColor!}
  />
  <DeleteTagModal
    tagId={data.tagId!}
    onSubmit={updateTagList}
  />
</>;

export const getColumns = (updateTagList: () => void, tagList: TagInfo[]) => [
  {
    title: '标签ID',
    dataIndex: 'tagId',
    width: 320,
  },
  {
    title: '标签名称',
    dataIndex: 'tagName',
  },
  {
    title: '标签颜色',
    dataIndex: 'tagColor',
    width: 320,
    render: (tagColor: string) => getColorLabel(tagColor, true),
  },
  {
    title: '操作',
    width: 320,
    render: (data: TagInfo) => renderOperate(data, updateTagList, tagList),
  },
];

export const getColorLabel = (color: string, showName?: boolean) => {
  const name = TAG_COLOR_INFO.find(item => item.color === color)?.name ?? '';
  return <div
    data-tid={`${DATA_TID.select.tagColorItem}-${name}`}
    style={{ display: 'flex', alignItems: 'center' }}>
    <div style={{
      backgroundColor: color,
      width: '22px',
      height: '22px',
      lineHeight: '40px',
      borderRadius: '12px',
    }}></div>
    {showName && <div style={{ marginLeft: '8px' }}>{name}</div>}
  </div>;
};
